import {
  getAmbassadorReferral,
  getBtReferral,
  getDirectReferral,
} from "../../services/api";
import * as types from "../types";

//Ambassador Referrals
const ambassadorReferralRequest = () => ({
  type: types.REFERRAL_AMBASSADOR_REQUEST,
});

const ambassadorReferralSuccess = (data) => ({
  type: types.REFERRAL_AMBASSADOR_SUCCESS,
  payload: data,
});
const ambassadorReferralFailure = (error) => ({
  type: types.REFERRAL_AMBASSADOR_FAILURE,
  payload: error,
});

export const getAmbassadorReferralAction = (queryParams) => {
  return async (dispatch) => {
    dispatch(ambassadorReferralRequest());
    try {
      const response = await getAmbassadorReferral(queryParams);
      dispatch(ambassadorReferralSuccess(response.data));
    } catch (error) {
      dispatch(ambassadorReferralFailure(error.message));
    }
  };
};

//BT Referrals

const BtReferralRequest = () => ({
  type: types.REFERRAL_BT_REQUEST,
});

const BtReferralSuccess = (data) => ({
  type: types.REFERRAL_BT_SUCCESS,
  payload: data,
});
const BtReferralFailure = (error) => ({
  type: types.REFERRAL_BT_FAILURE,
  payload: error,
});

export const getBtReferralAction = (queryParams) => {
  return async (dispatch) => {
    dispatch(BtReferralRequest());
    try {
      const response = await getBtReferral(queryParams);
      dispatch(BtReferralSuccess(response.data));
    } catch (error) {
      dispatch(BtReferralFailure(error.message));
    }
  };
};

//Direct Referrals

const DirectReferralRequest = () => ({
  type: types.REFERRAL_DIRECT_REQUEST,
});

const DirectReferralSuccess = (data) => ({
  type: types.REFERRAL_DIRECT_SUCCESS,
  payload: data,
});
const DirectReferralFailure = (error) => ({
  type: types.REFERRAL_DIRECT_FAILURE,
  payload: error,
});

export const getDirectReferralAction = (queryParams) => {
  return async (dispatch) => {
    dispatch(DirectReferralRequest());
    try {
      const response = await getDirectReferral(queryParams);
      dispatch(DirectReferralSuccess(response.data));
    } catch (error) {
      dispatch(DirectReferralFailure(error.message));
    }
  };
};
